module.exports = __webpack_public_path__ + "static/img/lang.a9e2fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lang.png
// module id = Ea7o
// module chunks = 104